import { RadioButtonList } from '@interstate/components/RadioButtonList';
import { usePaymentFrequencyField } from './hooks/usePaymentFrequencyField';

const PaymentFrequency = () => {
    const { label, radioProps } = usePaymentFrequencyField();

    return (
        <RadioButtonList
            sx={{
                '.MuiFormGroup-root': {
                    padding: '0px!important',
                    paddingLeft: '0.3rem!important'
                },
                '.MuiFormControlLabel-root': {
                    marginRight: '1.3rem!important;'
                }
            }}
            label={label}
            {...radioProps}
            spacing="sm"
            labelSize="sm"
            inline={true}
        />
    );
};

export default PaymentFrequency;
